
import useAppConfigStore from '@/store/app-config'
import useVerticalMenuStore from '@/store/vertical-menu'


export default function usAppConfig() {

  const app_config_store = useAppConfigStore();
  const vertical_menu_store = useVerticalMenuStore();
  
  // ------------------------------------------------
  // isVerticalMenuCollapsed
  // ------------------------------------------------
  const isVerticalMenuCollapsed = computed({
    get: () => vertical_menu_store.isVerticalMenuCollapsed,
    set: (val) => vertical_menu_store.UPDATE_VERTICAL_MENU_COLLAPSED(val)
  });



  // ------------------------------------------------
  // Skin
  // ------------------------------------------------
  const skin = computed({
    get: () => app_config_store.layout.skin,
    set: (val) => app_config_store.UPDATE_SKIN(val)
  });

  const isDarkSkin = computed(() => skin.value === 'dark')

  const skinClasses = computed(() => {
    if (skin.value === 'bordered') return 'bordered-layout'
    if (skin.value === 'semi-dark') return 'semi-dark-layout'

    // Do not return any class for dark layout because dark layout updates class in body
    // Do not return any class for light layout as that is default layout
    return null
  })

  // ------------------------------------------------
  // routerTransition
  // ------------------------------------------------
  const routerTransition = computed({
    get: () => app_config_store.layout.routerTransition,
    set: (val) => app_config_store.UPDATE_ROUTER_TRANSITION(val)
  });

  // *===============================================---*
  // *--------- LAYOUT ---------------------------------------*
  // *===============================================---*

  // ------------------------------------------------
  // layoutType
  // ------------------------------------------------

  const layoutType = computed({
    get: () => app_config_store.layout.type,
    set: (val) => app_config_store.UPDATE_LAYOUT_TYPE(val)
  });

  // Reset skin if skin is semi-dark and move to horizontal layout
  watch(layoutType, val => {
    if (val === 'horizontal' && skin.value === 'semi-dark') skin.value = 'light'
  })

  // ------------------------------------------------
  // Content Width (Full/Boxed)
  // ------------------------------------------------
  const contentWidth = computed({
    get: () => app_config_store.layout.contentWidth,
    set: (val) => app_config_store.UPDATE_CONTENT_WIDTH(val)
  });

  // ------------------------------------------------
  // isNavMenuHidden
  // ------------------------------------------------
  const isNavMenuHidden = computed({
    get: () => app_config_store.layout.menu.hidden,
    set: (val) => app_config_store.UPDATE_NAV_MENU_HIDDEN(val)
  });

  // *===============================================---*
  // *--------- NAVBAR ---------------------------------------*
  // *===============================================---*

  const navbarBackgroundColor = computed({
    get: () => app_config_store.layout.navbar.backgroundColor,
    set: (val) => app_config_store.UPDATE_NAVBAR_CONFIG(val)
  });

  const navbarType = computed({
    get: () => app_config_store.layout.navbar.type,
    set: (val) => app_config_store.UPDATE_NAVBAR_CONFIG({type:val})
  });

  // *===============================================---*
  // *--------- FOOTER ---------------------------------------*
  // *===============================================---*

  const footerType = computed({
    get: () => app_config_store.layout.footer.type,
    set: (val) => app_config_store.UPDATE_FOOTER_CONFIG({type:val})
  });

  return {
    isVerticalMenuCollapsed,
    skin,
    isDarkSkin,
    skinClasses,
    routerTransition,

    // Navbar
    navbarBackgroundColor,
    navbarType,

    // Footer
    footerType,

    // Layout
    layoutType,
    contentWidth,
    isNavMenuHidden,
  }
}
